import React, { useState } from "react";
import { createUserWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { sendWelcomeEmail } from "../services/emailNotifications";

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("donor"); // Rol por defecto
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Función para registrar con correo y contraseña
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Guardar información adicional en Firestore
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        role: role,
        createdAt: new Date(),
      });

      await sendWelcomeEmail({
        to: user.email,
        name: user.displayName || user.email?.split("@")?.[0],
        role,
      });

      alert("Usuario registrado correctamente");
      navigate(role === "donor" ? "/add-medication" : "/home"); // Redirigir según el rol
    } catch (error) {
      setError("Error al registrar: " + error.message);
    }
  };

  // Función para registrar/iniciar sesión con Google
  const handleGoogleSignIn = async (selectedRole) => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Guardar información adicional en Firestore
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        role: selectedRole, // Usar el rol seleccionado
        createdAt: new Date(),
      });

      await sendWelcomeEmail({
        to: user.email,
        name: user.displayName || user.email?.split("@")?.[0],
        role: selectedRole,
      });

      alert("Inicio de sesión con Google exitoso");
      navigate(selectedRole === "donor" ? "/add-medication" : "/home"); // Redirigir según el rol
    } catch (error) {
      setError("Error al iniciar sesión con Google: " + error.message);
    }
  };

  return (
    <div>
      <h2>Registro</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <select value={role} onChange={(e) => setRole(e.target.value)} required>
          <option value="donor">Donante</option>
          <option value="requester">Solicitante</option>
        </select>
        <button type="submit">Registrarse</button>
      </form>

      <div>
        <p>O regístrate con Google:</p>
        <button onClick={() => handleGoogleSignIn("donor")}>Registrarse como Donante</button>
        <button onClick={() => handleGoogleSignIn("requester")}>Registrarse como Solicitante</button>
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default Register;
